import { Fragment, useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivateRoutes from "./components/PrivateRouter";
import Dashboard from "./components/Dashboard";
import Statement3 from "./components/Statement3";
import Folder from "./components/Folder";
import Login from "./components/Login";
import FileUpload from "./components/FileUpload";
import Instruction from "./components/files/Instruction";
import UserModule from "./components/User";
import UserList from "./components/user/UserList";
import AddUser from "./components/user/AddUser";
import EditUser from "./components/user/EditUser";
import UnAuthorized from "./components/common/UnAuthorized";
import AssignClient from "./components/user/AssignClient";
import { GoogleOAuthProvider } from "@react-oauth/google";

import "./App.css";
import Gstr1 from "./components/Gstr1";
import { Toaster } from "react-hot-toast";
import Refunds from "./components/refund/Refunds";
import LitigationComponent from "./components/litigation/Litigation";
import GstRepoComponent from "./components/gstRepo/GstRepo";
import HsnSacComponent from "./components/HSN/hsnSac";
import ExportImportFacilitation from "./components/ExportImportFacilitation/ExportImportFacilitation";
import QueryDetailsPage from "./components/HSN/QueryDetailsPage";

import Clients from "./components/Clients";
import PendingClients from "./components/PendingClients";
import TaxForms from "./components/TaxForms";
import Forex from "./components/Forex/Forex";
import ManageProfile from "./components/ManageProfile";
import Gstr3b from "./components/gstr3b/Gstr3b";
import Gstr9 from "./components/gstr9/Gstr9";
import Gstr9c from "./components/gstr9c/Gstr9c";
import { generateToken } from "./notification/firebaseConfig";
import { useDispatch } from "react-redux";
import { setFcmDeviceToken, setFcmNotification } from "./slices/notificationReducer";
import { getFiles } from "../src/slices/fileUploadReducer"
import ManageRoles from "./components/roles/ManageRoles";
import ViewRoles from "./components/roles/ViewRoles";
import NotificationPage from "./components/common/NotificationPage";
import SearchPage from "./components/common/SearchPage";
import ManageDepartment from "./components/department/ManageDepartment";
import ViewDepartment from './components/department/ViewDepartment';
import Employees from "./components/Employees/Employees";
import ClientList from "./components/clients/ClientList";
import ClientProcess from './components/clients/ClientProcess';
import ActivityLog from './components/ActivityLog/ActivityLog';
import MonthlyRatesList from './components/monthlyRates/MonthlyRatesList';
import 'react-datepicker/dist/react-datepicker.css';
import ResetPassword from './components/user/ResetPassword';
import ResetPasswordConfirm from './components/user/ResetPasswordConfirm';
import BrcDashboard from "./components/BRC/BrcDashboard";
import UploadStatusPage from "./components/BRC/UploadStatusPage";
import ManualUploadStatusPage from "./components/BRC/ManualBRC/ManualUploadStatusPage";
import UploadStatusTab from "./components/BRC/UploadStatusTab";
import PortWiseReport from "./components/BRC/PortWiseReport";
import FullPageLoader from "./components/BRC/FullPageLoader";
import ScripReport from "./components/BRC/ScripReport/scripReport";
import SinglePortCodeView from "./components/BRC/ScripReport/SinglePortCodeView";
import PeriodCreatedList from "./components/EBRC/PeriodCreatedList";
import IRMDetails from "./components/EBRC/IRMDetails";

function App() {

  const dispatch = useDispatch();
  const [foregroundMessageReceived] = useState(false);

  useEffect(() => {
    const setToken = async () => {
      const deviceToken = await generateToken();
      if (deviceToken)
        dispatch(setFcmDeviceToken(deviceToken));
      /*onMessage(messaging, (payload) => {
        console.log('Message received. ', payload.data);
        setForegroundMessageReceived(true); 
        dispatch(setFcmNotification(payload.data));
      });*/
    }
    setToken();
  }, [dispatch]);

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (!foregroundMessageReceived && event.data?.data?.fcm_app === 'admin') {
          console.log('Received message from service worker:', event.data?.data);
          dispatch(setFcmNotification(event.data?.data));
          try {
            const data = event.data?.data;
            if (data?.action_type === "statement3_upload" && data.folder_id) {
              dispatch(getFiles({ folder_id: data.folder_id }));
            } else if (!data?.action_type || !data?.folder_id) {
              console.warn(
                "Action type or folder_id is missing or invalid:",
                data
              );
            }
          } catch (error) {
            console.error(
              "An error occurred while processing the event:",
              error
            );
          }

        }
      });
    }
  }, [foregroundMessageReceived, dispatch]);
  return (
    <Fragment>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <Router>
          <Toaster
            position="top-center"
            containerStyle={{
              zIndex: 99999,  // Apply to container
            }}
            toastOptions={{
              duration: 3000,
              style: {
                zIndex: 99999,  // Apply to individual toasts
              },
              success: {
                style: {
                  zIndex: 99999,
                },
              },
              error: {
                style: {
                  zIndex: 99999,
                },
              },
            }}
          />
          <FullPageLoader />
          <Routes>
            <Route element={<PrivateRoutes />}>
              <Route element={<Dashboard />} path="/" />
              <Route element={<Statement3 />} path="/statement3" />
              <Route element={<Forex />} path="/forex" />
              <Route element={<Clients />} path="/clients" />
              <Route element={<PendingClients />} path="/pending-clients" />
              <Route element={<ManageRoles />} path="/manage-roles" />
              <Route element={<ViewRoles />} path="/view-roles" />
              <Route path="/activity-log" element={<ActivityLog />} />
              <Route path="/monthly-rates" element={<MonthlyRatesList />} />
              <Route path="/scrip/report/:client_id" element={<ScripReport />} />

              <Route
                element={<TaxForms />}
                path="/clients/tax-forms/:client_id"
              />
              <Route element={<Gstr1 />} path="/gstr-1/:client_id" />
              <Route element={<Gstr3b />} path="/gstr3b/:client_id" />
              <Route element={<Gstr9 />} path="/gstr9/:client_id" />
              <Route element={<Gstr9c />} path="/gstr9c/:client_id" />
              <Route element={<Refunds />} path="/refunds/:client_id" />
              <Route element={<LitigationComponent />} path="/litigation/:client_id" />
              <Route element={<GstRepoComponent />} path="/gstrepo/:client_id" />
              <Route element={<ExportImportFacilitation />} path="/Export-Import-Facilitation" />
              <Route element={<HsnSacComponent />} path="/hsn/sac" />
              <Route element={<QueryDetailsPage />} path="/query-details/:client_id/:query_id" />
              <Route element={<Folder />} path="/periods/:client_id" />
              <Route path="/notifications" element={<NotificationPage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route element={<FileUpload />} path="/files/:folder_id" />
              <Route element={<Instruction />} path="/instructions" />
              <Route element={<UserModule />} path="/user-management">
                <Route element={<UserList />} index />
                <Route element={<AddUser />} path="add-user" />
                <Route element={<EditUser />} path="edit-user/:user_id" />

                <Route
                  element={<AssignClient />}
                  path="assign-client/:user_id"
                />
              </Route>
              <Route path="/client-management" element={<ClientList />} />
              <Route path="/client-process/:id" element={<ClientProcess />} />
              <Route path="/RoDTEP/RoSCTL/:client_id" element={<BrcDashboard />} />
              <Route path="/RoDTEP/RoSCTL/reports/:client_id/:report_id" element={<UploadStatusPage />} />
              <Route path="/RoDTEP/RoSCTL/reports/manual/:client_id/:report_id" element={<ManualUploadStatusPage />} />

              <Route path="/port/report/status/:client_id/:report_id" element={<PortWiseReport />} />
              <Route path="/port-code-details/:client_id/:report_id/:port_code_id" element={<SinglePortCodeView />} />
              <Route path="/RoDTEP/RoSCTL/status/:client_id" element={<UploadStatusTab />} />

              <Route path="/ebrc/:client_id" element={<PeriodCreatedList />} />
              <Route path="/irm/details/:client_id/:period_id" element={<IRMDetails />} />
              <Route element={<ManageDepartment />} path="/manage-department" />
              <Route path="/departments/:department_id" element={<ViewDepartment />} />

              <Route element={<Employees />} path="/employee/:user_id" />
              <Route element={<UnAuthorized />} path="/authorization-error" />
              <Route element={<ManageProfile />} path="/manage-profile" />
            </Route>
            <Route element={<Login />} path="/login" />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/reset-password/:uid/:token/" element={<ResetPasswordConfirm />} />

          </Routes>
        </Router>
      </GoogleOAuthProvider>
    </Fragment>
  );
}

export default App;
